import Carousel from './Carousel';

const carouselConfig = {
  name: 'carousel',
  class: Carousel,
  querySelector: {
    viewport: '.carousel__viewport',
    navigationThumbWrapper: '.carousel__navigation-thumbs',
    navigationPrev: '.carousel__navigation-prev',
    navigationNext: '.carousel__navigation-next',
  },
  querySelectorAll: {
    navigationThumbs: '.carousel__navigation-thumb',
  },
  options: {
    navSlideActiveClass: 'carousel__navigation-thumb--active',
  },
};

export default carouselConfig;



// WEBPACK FOOTER //
// ./client/js/components/Carousel/carouselConfig.js